import { ApolloError } from '@apollo/client';
import { payments as schemaPayments } from './schemas';
import apiClient from './apiClient';
import PaymentsDataStore from '../../datastores/PaymentsDataStore';

class PaymentsDataStoreGraphQL implements PaymentsDataStore {
  // async getPayments() {
  //   try {
  //     const client = apiClient();
  //     const response = await client.query({
  //       query: schemaPayments.getPayments
  //     });
  //     return response.data;
  //   } catch (err) {
  //     if (err instanceof ApolloError) {
  //       throw new Error('No se pudo obtener los pagos');
  //     }
  //     throw err;
  //   }
  // }

  async getPaymentBanks() {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaPayments.getPaymentBanks
      });
      return response.data.paymentBank;
    } catch (err) {
      if (err instanceof ApolloError) {
        throw new Error('No se pudo obtener los bancos de pago');
      }
      throw err;
    }
  }

  async getPendingPayments() {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaPayments.getPendingPayments
      });
      return response;
    } catch (err) {
      if (err instanceof ApolloError) {
        throw new Error('No se pudo obtener los pagos pendientes');
      }
      throw err;
    }
  }

  async getPaidPayments(period: string) {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaPayments.getPaidPayments,
        variables: { period }
      });
      return response;
    } catch (err) {
      if (err instanceof ApolloError) {
        throw new Error('No se pudo obtener los pagos realizados');
      }
      throw err;
    }
  }

  async getBenefitInstallments() {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaPayments.getBenefitInstallments
      });
      return response.data;
    } catch (err) {
      if (err instanceof ApolloError) {
        throw new Error('No se pudo obtener las cuotas de beneficio');
      }
      throw err;
    }
  }

  async getBenefitInstallmentsInfo() {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaPayments.getBenefitInstallmentsInfo
      });
      return response.data;
    } catch (err) {
      if (err instanceof ApolloError) {
        throw new Error('No se pudo obtener las cuotas de beneficio');
      }
      throw err;
    }
  }

  async activateBenefitInstallments(active: boolean) {
    try {
      const client = apiClient();
      const response = await client.mutate({
        mutation: schemaPayments.activateBenefitInstallments,
        variables: { isActivate: active }
      });
      if (response.errors) throw new Error('error');
      return response.data;
    } catch (err) {
      if (err instanceof ApolloError) {
        throw new Error('No se pudo activar el ciclo completo');
      }
      throw err;
    }
  }

  async getPaymentVouchers(itemNbr: any) {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaPayments.getPaymentVouchers,
        variables: { itemNbr }
      });
      return response.data.paymentVouchers;
    } catch (err) {
      if (err instanceof ApolloError) {
        throw new Error('No se pudo obtener los vouchers de pago');
      }
      throw err;
    }
  }

  async generatePaymentVoucher(
    companyID: string,
    documentNumber: string,
    documentType: string,
    internalSeries: string,
    documentDate: string,
    totalAmount: number
  ) {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaPayments.generatePayroll,
        variables: {
          companyID,
          documentNumber,
          documentType,
          internalSeries,
          documentDate,
          totalAmount
        }
      });
      return response.data.generatePayrollPDF;
    } catch (err) {
      if (err instanceof ApolloError) {
        throw new Error('No se pudo generar el voucher de pago');
      }
      throw err;
    }
  }

  async getPaymentPeriods() {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaPayments.getPaymentPeriods
      });
      return response.data.paymentPeriods;
    } catch (err) {
      if (err instanceof ApolloError) {
        throw new Error('No se pudo obtener los períodos de pago');
      }
      throw err;
    }
  }

  async getPaymentsByPeriod(period: string) {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaPayments.getPaymentsByPeriod,
        variables: { period }
      });
      return response.data;
    } catch (err) {
      if (err instanceof ApolloError) {
        throw new Error('No se pudo obtener los pagos por período');
      }
      throw err;
    }
  }
}

export default PaymentsDataStoreGraphQL;
